"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.EIP4337Fallback__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_eip4337manager",
                type: "address"
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "NAME",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "eip4337manager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "enum Enum.Operation",
                name: "",
                type: "uint8"
            },
        ],
        name: "executeAndRevert",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_hash",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "_signature",
                type: "bytes"
            },
        ],
        name: "isValidSignature",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]"
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
        ],
        name: "onERC1155BatchReceived",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4"
            },
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
        ],
        name: "onERC1155Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4"
            },
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4"
            },
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
        ],
        name: "tokensReceived",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "sender",
                        type: "address"
                    },
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256"
                    },
                    {
                        internalType: "bytes",
                        name: "initCode",
                        type: "bytes"
                    },
                    {
                        internalType: "bytes",
                        name: "callData",
                        type: "bytes"
                    },
                    {
                        internalType: "uint256",
                        name: "callGasLimit",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "verificationGasLimit",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "preVerificationGas",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "maxFeePerGas",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "maxPriorityFeePerGas",
                        type: "uint256"
                    },
                    {
                        internalType: "bytes",
                        name: "paymasterAndData",
                        type: "bytes"
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes"
                    },
                ],
                internalType: "struct UserOperation",
                name: "",
                type: "tuple"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        name: "validateUserOp",
        outputs: [
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
];
var _bytecode = "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";
var isSuperArgs = function (xs) { return xs.length > 1; };
var EIP4337Fallback__factory = /** @class */ (function (_super) {
    __extends(EIP4337Fallback__factory, _super);
    function EIP4337Fallback__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    EIP4337Fallback__factory.prototype.deploy = function (_eip4337manager, overrides) {
        return _super.prototype.deploy.call(this, _eip4337manager, overrides || {});
    };
    EIP4337Fallback__factory.prototype.getDeployTransaction = function (_eip4337manager, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _eip4337manager, overrides || {});
    };
    EIP4337Fallback__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    EIP4337Fallback__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    EIP4337Fallback__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    EIP4337Fallback__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    EIP4337Fallback__factory.bytecode = _bytecode;
    EIP4337Fallback__factory.abi = _abi;
    return EIP4337Fallback__factory;
}(ethers_1.ContractFactory));
exports.EIP4337Fallback__factory = EIP4337Fallback__factory;
